module.exports = __webpack_public_path__ + "398bcf751f8e43722092f9b0f10515c9.svg";